import React /*useContext*/ /*, useMemo*/ from 'react';
import { useParams, useLocation, Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom-v5-compat';
import { Nav, Navbar, ButtonGroup, Dropdown, NavDropdown } from 'react-bootstrap';
// import { UserContext } from 'components/contexts/UserProvider';
// import { WithPermission } from '@lib/helpers/WithPermission';
import { useHasPermission } from '@lib/hooks/useHasPermission';

const ProjectNavHorizontal = ({ isCoordinator, isBeneficiary, projectAdvancedConfig }) => {
	// const { /*isOe,*/ userAccess } = useContext(UserContext);

	const { projectId } = useParams();
	const { tab, submenu } = useParams();
	const location = useLocation();
	const isProjectSection = location.pathname.split('/').slice(0, 2).join('/') === '/project';
	// const executionSubtab = useMemo(
	// 	() =>
	// 		projectAdvancedConfig && projectAdvancedConfig.some((el) => el.name === 'can_generate_templates' && el.enabled)
	// 			? 'configuration-template'
	// 			: 'contracts',
	// 	[projectAdvancedConfig],
	// );
	const navigate = useNavigate();

	if (!tab) navigate(`/project/${projectId}/dashboard`);

	const routes = [
		{
			key: `dashboard`,
			label: 'Dashboard',
		},
		{
			key: `candidacy`,
			label: 'Candidatura',
			shouldBeVisible: useHasPermission('view-candidatura-tab'),
		},
		{
			key: `planning`,
			label: 'Pianificazione',
			shouldBeVisible: useHasPermission('view-pianificazione-tab'),
		},
		{
			key: `execution`,
			label: 'Avanzamento',
			shouldBeVisible: useHasPermission('view-avanzamento-tab'),
			subroutes: [
				{
					key: `execution/economic`,
					label: 'Economico',
					shouldBeVisible: useHasPermission('view-avanzamento-economico-tab'),
				},
				{
					key: `execution/physical`,
					label: 'Fisico',
					shouldBeVisible: useHasPermission('view-avanzamento-fisico-tab'),
				},
			],
		},
		{
			key: `summary`,
			label: 'Controllo',
		},
		{
			key: `advancement`,
			label: 'Monitoraggio',
			shouldBeVisible: useHasPermission('view-monitoraggio-tab'),
		},
		{
			key: `reporting`,
			label: 'Rendicontazione',
			shouldBeVisible: useHasPermission(['view-rendicontazione-dnsh-tab', 'view-reports-history', 'view-draft-statements'], 'any'),
		},
	];

	return (
		<>
			{isProjectSection && (
				<Navbar
					// className="sub-navbar"
					className="custom-subnav"
				>
					<Nav activeKey={tab} className="gap-4 align-items-center">
						{routes.map((route) => {
							if (route.shouldBeVisible === false) return null;

							if (route.subroutes) {
								return (
									<NavDropdown
										as={ButtonGroup}
										className="sub-nav-dropdown horizontal"
										title={route.label}
										key={route.key}
										active={tab === route.key}
									>
										{route.subroutes.map((subroute) => {
											if (subroute.shouldBeVisible === false) return null;

											const isActive = `${tab}/${submenu}` === subroute.key;

											return (
												<Dropdown.Item
													as={isActive ? 'span' : Link}
													to={`/project/${projectId}/${subroute.key}`}
													eventKey={subroute.key}
													key={subroute.key}
													active={isActive}
													style={{
														cursor: isActive ? 'default' : 'pointer',
													}}
												>
													{subroute.label}
												</Dropdown.Item>
											);
										})}
									</NavDropdown>
								);
							}

							return (
								<Nav.Item key={route.key}>
									{tab === route.key ? (
										<span
											className="nav-link active"
											style={{
												cursor: 'default',
											}}
										>
											{route.label}
										</span>
									) : (
										<Nav.Link as={Link} to={`/project/${projectId}/${route.key}`} eventKey={route.key}>
											{route.label}
										</Nav.Link>
									)}
								</Nav.Item>
							);
						})}

						{/* <Nav.Item>
							<Nav.Link as={Link} to={`/project/${projectId}/dashboard`} eventKey="dashboard">
								Dashboard
							</Nav.Link>
						</Nav.Item>

						<WithPermission permission="view-candidatura-tab">
							<Nav.Item>
								<Nav.Link as={Link} to={`/project/${projectId}/candidacy`} eventKey="candidacy">
									Candidatura
								</Nav.Link>
							</Nav.Item>
						</WithPermission>

						<WithPermission permission="view-pianificazione-tab">
							<Nav.Item>
								<Nav.Link as={Link} to={`/project/${projectId}/planning`} eventKey="planning">
									Pianificazione
								</Nav.Link>
							</Nav.Item>
						</WithPermission>

						<WithPermission permission="view-avanzamento-tab">
							{(isCoordinator || (userAccess.isAboveGuest && isBeneficiary === false)) && (
								<Nav activeKey={submenu} className="sub-nav-dropdown">
									<NavDropdown as={ButtonGroup} className="sub-nav-dropdown horizontal" title="Avanzamento" active={tab === 'execution'}>
										<WithPermission permission="view-avanzamento-economico-tab">
											<Dropdown.Item
												as={Link}
												to={`/project/${projectId}/execution/economic`}
												// #${isOe || isCoordinator ? executionSubtab : 'industrialaccounts'}
												eventKey="economic"
											>
												Economico
											</Dropdown.Item>
										</WithPermission>

										<WithPermission permission="view-avanzamento-fisico-tab">
											<Dropdown.Item as={Link} to={`/project/${projectId}/execution/physical`} eventKey="physical">
												Fisico
											</Dropdown.Item>
										</WithPermission>
									</NavDropdown>
								</Nav>
							)}
						</WithPermission>

						<Nav.Item>
							<Nav.Link as={Link} to={`/project/${projectId}/summary`} eventKey="summary">
								Controllo
							</Nav.Link>
						</Nav.Item>

						<WithPermission permission="view-monitoraggio-tab">
							<Nav.Item>
								<Nav.Link as={Link} to={`/project/${projectId}/advancement`} eventKey="advancement">
									Monitoraggio
								</Nav.Link>
							</Nav.Item>
						</WithPermission>

						<WithPermission permission={['view-rendicontazione-dnsh-tab', 'view-reports-history', 'view-draft-statements']} mode="any">
							<Nav.Item>
								<Nav.Link as={Link} to={`/project/${projectId}/reporting`} eventKey="reporting">
									Rendicontazione
								</Nav.Link>
							</Nav.Item>
						</WithPermission> */}
					</Nav>
				</Navbar>
			)}
		</>
	);
};
export default ProjectNavHorizontal;
